import { isEmpty } from 'lodash/fp'

import {
  fetchResellerAgreementData,
  syncAWSResellerAgreementDataToDb,
} from '../../../api/marketplace/index'
import type { ProcessReceivedResellerAgreementsForCPParams } from '../types'
import { getReceivedResellerAgreementSearchParams } from './getReceivedResellerAgreementSearchParams'

export const processReceivedResellerAgreementsForCP = async ({
  partnerId,
  pageSize,
  pageNumber,
  productId,
  crmOpportunityId,
  status,
  input,
  selectedInput,
  cloudProductUid,
}: ProcessReceivedResellerAgreementsForCPParams) => {
  // Received resale authorizations search now queries the marketplace service
  // directly (DB-backed) instead of going through the OpenSearch based search
  // service.
  const receivedResaleAuthsInDbResponse = await fetchResellerAgreementData({
    partnerId,
    pageSize,
    pageNumber,
    sortBy: 'created_at',
    sortOrder: 'desc',
    productId,
    crmOpportunityId,
    status: status || '',
    origin: 'RECEIVED',
    cloudProductUid,
    ...getReceivedResellerAgreementSearchParams(input, selectedInput),
  })

  if (!isEmpty(input) || receivedResaleAuthsInDbResponse.data) {
    return receivedResaleAuthsInDbResponse
  }

  return syncAWSResellerAgreementDataToDb(partnerId, 'RECEIVED')
}
